// ================ Action types ================ //

export const LOCATION_CHANGED = 'app/routing/LOCATION_CHANGED';
export const ROUTE_TRANSITION_START = 'app/routing/ROUTE_TRANSITION_START';
export const ROUTE_TRANSITION_END = 'app/routing/ROUTE_TRANSITION_END';

// ================ Reducer ================ //

const initialState = {
  currentLocation: null,
  currentCanonicalPath: null,
  isRouteTransitioning: false,
  pendingLocation: null,
  transitionId: null,
};

export default function routingReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case LOCATION_CHANGED:
      return {
        ...state,
        currentLocation: payload.location,
        currentCanonicalPath: payload.canonicalPath,
      };
    case ROUTE_TRANSITION_START:
      return {
        ...state,
        isRouteTransitioning: true,
        pendingLocation: payload.location,
        transitionId: payload.transitionId,
      };
    case ROUTE_TRANSITION_END:
      if (state.transitionId !== payload.transitionId) {
        return state;
      }

      return {
        ...state,
        isRouteTransitioning: false,
        pendingLocation: null,
      };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const locationChanged = (location, canonicalPath) => ({
  type: LOCATION_CHANGED,
  payload: { location, canonicalPath },
});

export const routeTransitionStart = (location, transitionId) => ({
  type: ROUTE_TRANSITION_START,
  payload: { location, transitionId },
});

export const routeTransitionEnd = transitionId => ({
  type: ROUTE_TRANSITION_END,
  payload: { transitionId },
});
